import { ProgramType, EnabledFeatures, IEnabledFeatures } from 'fitbeat.models';
import { BigBodyGroup, CardioOrResistance, Level } from '../entities/exercise';
import { WorkoutSettings } from '../entities/user';

export interface IWorkoutSettingsWithDescription {
  description: string;
  workoutSettings: WorkoutSettings;
}

export class ProgramsConfig {
  public static workoutDescriptions: IWorkoutSettingsWithDescription[] = [
    // Cardio
    {
      description:
        'A fast-paced, high-intensity Burn (cardio) workout. Full body activation with an emphasis on the lower body. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Lower],
      }),
    },
    {
      description:
        'A fast-paced, high-intensity Burn (cardio) workout. Full body activation with an emphasis on the upper body. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Upper],
      }),
    },
    {
      description:
      'A fast-paced, high-intensity Burn (cardio) workout. Full body activation with an emphasis on the back & arms. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
      }),
    },
    {
      description:
        'A fast-paced, high-intensity Burn (cardio) workout. Full body activation. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.Upper, BigBodyGroup.BackAndArms],
      }),
    },
    // Resistance
    {
      description:
        'A slower-paced, heavy-lifting, Build (resistance) workout. Exclusive focus on the lower body. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Lower],
      }),
    },
    {
      description:
        'A slower-paced, heavy-lifting, Build (resistance) workout. Exclusive focus on the upper body. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Upper],
      }),
    },
    {
      description:
        'A slower-paced, heavy-lifting, Build (resistance) workout. Exclusive focus on the back & arms. ',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
      }),
    },
    {
      description:
        'A slower-paced, heavy-lifting Build (resistance) workout.',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.Upper, BigBodyGroup.BackAndArms],
      }),
    },
    // Balance
    {
      description:
        'A slower-paced, mobility & core Balance (Pilates) workout.',
      workoutSettings: new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Balance,
        threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.Upper, BigBodyGroup.BackAndArms],
      }),
    },
  ];

  public static readonly userDefaultProgramsConfig: Map<ProgramType, WorkoutSettings[]> = new Map([
    [ProgramType.GetLeanAndFitGoal, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Lower],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
    ],
    ],
    [ProgramType.GainMuscleAndStrengthGoal, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Lower],
        level: Level.Intermediate,
      })],
    ],
    [ProgramType.GetStrongAndFitGoal, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Lower],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.Lower],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      })],
    ],
    [ProgramType.MobilityAndTone, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Balance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      })],
    ],
    [ProgramType.MuscleAndShred, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.Lower],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      })],
    ],
  ]);

  public static readonly noEquipmentProgramsConfig: Map<ProgramType, WorkoutSettings[]> = new Map([
    [ProgramType.GetLeanAndFitGoal, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      })],
    ],
    [ProgramType.GainMuscleAndStrengthGoal, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      })],
    ],
    [ProgramType.GetStrongAndFitGoal, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Cardio,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
    ]],
    [ProgramType.MobilityAndTone, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Balance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      }),
    ]],
    [ProgramType.MuscleAndShred, [
      new WorkoutSettings({
        cardioOrResistance: CardioOrResistance.Resistance,
        threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
        level: Level.Intermediate,
      })],
    ],
  ]);

  public static userProgramsConfig = ProgramsConfig.userDefaultProgramsConfig;

  public static noEquipmentUserProgramsConfig = ProgramsConfig.noEquipmentProgramsConfig;

  public static getWorkoutSettingDescription(
    workoutSettings: WorkoutSettings,
    isHomeGym: boolean,
    hasBagContact: boolean,
  ): string {
    const sortedBodyGroups = [...workoutSettings.threeBodyGroups].sort();
    const workoutSettingsWithDescription = ProgramsConfig.workoutDescriptions.find(
      (workoutDescriptions: IWorkoutSettingsWithDescription) => (
        workoutSettings.cardioOrResistance === workoutDescriptions.workoutSettings.cardioOrResistance
        && JSON.stringify(sortedBodyGroups)
          === JSON.stringify([...workoutDescriptions.workoutSettings.threeBodyGroups].sort())
      ),
    );
    const descriptionAddition = isHomeGym
      || workoutSettings.cardioOrResistance === CardioOrResistance.Balance
      || !hasBagContact
      ? '' : 'Combat training (boxing & MMA) is optional at check in.';
    return workoutSettingsWithDescription ? workoutSettingsWithDescription.description + descriptionAddition : '';
  }

  public static getProgramConfig(programType: ProgramType, noEquipment: boolean): WorkoutSettings[] | undefined {
    if (noEquipment) {
      return ProgramsConfig.noEquipmentUserProgramsConfig.get(programType);
    }
    return ProgramsConfig.userProgramsConfig.get(programType);
  }

  public static fallbackSettingsForGoal(programType: ProgramType, level: Level): WorkoutSettings {
    const settings = new WorkoutSettings({
      cardioOrResistance: CardioOrResistance.Resistance,
      threeBodyGroups: [BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper],
      level: level ?? Level.Beginner,
    });
    switch (programType) {
      case ProgramType.GetLeanAndFitGoal:
        settings.cardioOrResistance = CardioOrResistance.Cardio;
        break;
      case ProgramType.GainMuscleAndStrengthGoal:
        settings.cardioOrResistance = CardioOrResistance.Resistance;
        break;
      case ProgramType.GetStrongAndFitGoal:
        settings.cardioOrResistance = CardioOrResistance.Resistance;
        break;
      case ProgramType.MuscleAndShred:
        settings.cardioOrResistance = CardioOrResistance.Resistance;
        break;
      case ProgramType.MobilityAndTone:
        settings.cardioOrResistance = CardioOrResistance.Balance;
        break;
    }
    return settings;
  }
}

export interface IWorkoutGoalSettingCombinations {
  workoutDays: number;
  workoutSettings: WorkoutSettings[];
}

export interface IWorkoutProgramsWithDescription {
  programType: ProgramType;
  summary: string;
  workoutDescription: string;
  nutritionDescription: string;
  onBoardingWorkoutDescription: string;
  onBoardingNutritionDescription: string;
  onBoardingTrackingDescription: string;
}

const getEquipmentOptions = (enabledFeatures: IEnabledFeatures): string => {
  const hasStudioAccess = EnabledFeatures.hasAccessToAStudioGym(enabledFeatures);
  return hasStudioAccess
    ? 'Choose between equipment-free workouts, or using dumbbells, and a bench.'
    : 'Choose between equipment-free workouts and dumbbells (with the option to add a bench).';
};

const trackingDescription = 'Heart rate monitor training, body composition tracking and smart reports '
    + 'customised for your fitness goal.';

export const workoutProgramWithDescriptions = (enabledFeatures: IEnabledFeatures)
: IWorkoutProgramsWithDescription[] => [{
  programType: ProgramType.GainMuscleAndStrengthGoal,
  summary: 'Select this goal if you want to get bigger and more muscular.',
  workoutDescription: 'Select this goal if you want to get bigger and more muscular. '
    + 'Your training program will include gruelling "Build" workouts.',
  nutritionDescription: 'Your fitness goal requires large portion meals containing higher protein '
    + '& carbs to provide your body with essential nutrition to support your gruelling workouts. '
    + 'The meals are flavoursome to help you and your taste buds enjoy their muscle gaining journey.',
  onBoardingWorkoutDescription: 'With expert trainer guidance, your program focuses on Build (strength) '
    + 'workouts for maximum muscle-gain and strength, with optional Balance (Pilates) workouts for core strength. '
    + `${getEquipmentOptions(enabledFeatures)}`,
  onBoardingNutritionDescription: 'Recipes and shopping lists for larger portion meals with higher '
    + 'protein & quality carbs to fuel muscle growth.',
  onBoardingTrackingDescription: trackingDescription,
},
{
  programType: ProgramType.GetLeanAndFitGoal,
  summary: 'Select this goal if you want to get lean and improve your fitness.',
  workoutDescription: 'Select this goal if you want to get lean and improve your fitness. Your training program will '
    + 'focus on exhilarating "Burn" workouts with intermittent "Build" and "Balance" workouts',
  nutritionDescription: 'Your fitness goal demands meals that help you feel full for longer whilst losing weight. '
    + 'These quick & tasty, lower calorie, high protein meals will give you the '
    + 'stamina you need throughout your weight loss journey and fuel your body for your high intensity workouts.',
  onBoardingWorkoutDescription: 'With expert trainer guidance, your program includes mostly Burn (cardio) '
    + 'workouts to maximise weight-loss & fitness, and a full body Build (strength) workout to maintain '
    + 'lean muscle mass, with optional Balance (Pilates) workouts for core strength. '
    + `${getEquipmentOptions(enabledFeatures)}`,
  onBoardingNutritionDescription: 'Recipes and shopping lists for delicious calorie-controlled, macro-balanced meals '
    + 'to shred fat.',
  onBoardingTrackingDescription: trackingDescription,
},
{
  programType: ProgramType.GetStrongAndFitGoal,
  summary: 'Select this goal if you want a balance of everything (ie muscle strength, weight-loss & fitness).',
  workoutDescription: 'Select this goal if you want a balance of everything '
    + '(ie muscle strength, weight-loss, fitness, mobility and muscle tone). '
    + 'Your training program will include an equal balance of gruelling "Build" workouts, exhilarating "Burn" '
    + 'workouts and intermittent "Balance" workouts.',
  nutritionDescription: 'Your fitness goal requires high protein, quality carb meals aimed at '
    + 'assisting your muscle growth. These delicious tasting, quick and easy meals are designed to '
    + 'replenish your body of all its nutritional requirements.',
  onBoardingWorkoutDescription: 'With expert trainer guidance, your program includes Burn (cardio) '
    + 'and Build (strength) workouts, for a balance of weight loss, muscle gain and fitness, with optional '
    + 'Balance (Pilates) workouts for core strength. '
    + `${getEquipmentOptions(enabledFeatures)}`,
  onBoardingNutritionDescription: 'Recipes and shopping list for tasty, lower calorie, high protein meals '
    + 'to shed fat, improve fitness and build lean muscle.',
  onBoardingTrackingDescription: trackingDescription,
},
{
  programType: ProgramType.MobilityAndTone,
  summary: 'Select this goal if you want to improve your mobiliy and muscle tone.',
  workoutDescription: 'Select this goal if you want a to improve your mobility and muscle tone. '
    + 'Your training program will focus on Balance (Pilates) workouts.',
  nutritionDescription: 'Your fitness goal demands meals that help you feel full for longer whilst losing weight. '
    + 'These quick & tasty, lower calorie, high protein meals will give you the stamina you need '
    + 'throughout your weight loss journey and fuel your body for your high intensity workouts.',
  onBoardingWorkoutDescription: 'With expert trainer guidance, your program includes Balance (Pilates) '
    + 'workouts for core strengthening and muscle control, supporting everyday activities. '
    + `${getEquipmentOptions(enabledFeatures)}`,
  onBoardingNutritionDescription: 'Recipes and shopping lists for delicious calorie-controlled, '
    + 'macro-balanced meals to shred fat.',
  onBoardingTrackingDescription: trackingDescription,
},
{
  programType: ProgramType.MuscleAndShred,
  summary: 'Select this goal if you want to build muscle and shred fat.',
  workoutDescription: 'Select this goal if you want to get bigger and more muscular. '
    + 'Your training program will include gruelling "Build" workouts.',
  nutritionDescription: 'Your fitness goal requires high protein, quality carb meals aimed at '
    + 'assisting your muscle growth. These delicious tasting, quick and easy meals are designed to '
    + 'replenish your body of all its nutritional requirements.',
  onBoardingWorkoutDescription: 'With expert trainer guidance, your program focuses mainly on Build (strength) '
    + 'workouts for maximum muscle-gain, and a full body Burn (cardio) workout for fat loss, with optional '
    + 'Balance (Pilates) workouts for core strength. '
    + `${getEquipmentOptions(enabledFeatures)}`,
  onBoardingNutritionDescription: 'Recipes and shopping list for tasty, lower calorie, high protein meals '
    + 'to shed fat and build lean muscle.',
  onBoardingTrackingDescription: trackingDescription,
},
{
  programType: ProgramType.NotSet,
  summary: 'Select this option if you\'re not yet ready to commit to a long term goal or if you\'d prefer to manage '
    + 'your training program by yourself.',
  workoutDescription: 'Select this option if you\'re not yet ready to commit to a long term goal or if you\'d prefer '
    + 'to manage your training program by yourself.',
  nutritionDescription: 'Select your own meal plan. For best results please follow this guide: '
    + '\n\nYour workout program: mostly Burn classes\n* Select Lean & Fit Meal Plan'
    + '\n\nYour workout program: mostly Build classes\n* Select Muscle & Strength Meal Plan'
    + '\n\nYour workout program: Burn & Build classes\n* Select Strong & Fit Meal Plan.',
  onBoardingWorkoutDescription: '',
  onBoardingNutritionDescription: '',
  onBoardingTrackingDescription: '',
}];
